import { MapResponse } from '@empathy/search-adapter';
import { Tagging } from '@empathy/search-types';

export const mapResultTagging: MapResponse<any, Tagging> = (rawTagging, tagging) => {
  return Object.assign(tagging, {
    params: {
      ...tagging.params,
      page: Number(tagging.params.page)
    }
  });
};
